import {
  Box,
  Grid,
  Typography,
  Hidden,
  IconButton,
  LinearProgress,
  CardMedia,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useHistory } from 'react-router';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/contributor';
import { AMCAuthorisedSignatoryType } from '../../redux-store/types/api-types';
import { getAMCAuthorisedSignatoryById } from '../../redux-store/actions/userManagement';
import { Location } from 'history';

export default function AMCAuthoisedSignatoryDetails({
  location,
}: {
  location: Location<{ amcAuthorisedSignatoryId: number }>;
}): JSX.Element {
  const { amcAuthorisedSignatoryId: id } = location.state || { amcAuthorisedSignatoryId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [amcAuthorisedSignatoryTypeDetails, setAmcAuthorisedSignatoryTypeDetails] =
    useState<AMCAuthorisedSignatoryType>();

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        if (id) {
          const getAmcAuthorisedSignatoryTypeDetails = (await dispatch(
            getAMCAuthorisedSignatoryById(id)
          )) as unknown as AMCAuthorisedSignatoryType;
          setAmcAuthorisedSignatoryTypeDetails(getAmcAuthorisedSignatoryTypeDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          py: { xs: 2, sm: 5 },
          px: { xs: 0, sm: 5 },
          mt: { xs: 2, sm: 5 },
        }}>
        <Hidden smUp={true}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              aria-label="Back"
              title="Back"
              sx={{ height: 'fit-content', p: 0 }}
              onClick={() => history.push('amc-authorised-signatory')}>
              <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              component="h3"
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 2,
              py: 2,
              pl: { xs: 3, sm: 0 },
              color: 'primary.main',
              bgcolor: 'rgba(238, 244, 251, 0.5)',
            }}>
            <PersonOutlineOutlinedIcon fontSize="large" />
            <Typography
              component="h3"
              sx={{
                fontSize: 20,
                fontWeight: 600,
                pl: 1,
              }}>
              User Management
            </Typography>
          </Box>
        </Hidden>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden only="xs">
              <IconButton
                aria-label="Back"
                title="Back"
                sx={{ height: 'fit-content', p: 0 }}
                onClick={() => history.push('amc-authorised-signatory')}>
                <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
              </IconButton>
            </Hidden>
            <Typography
              component="h3"
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
                pl: { xs: 2, sm: 0 },
              }}>
              AMC Authorized Signatory
            </Typography>
          </Box>
          <IconButton
            aria-label="Edit AMC Authorized Signatory"
            title="Edit AMC Authorized Signatory">
            <CardMedia
              component="img"
              src="/images/edit-icon-outlined.svg"
              role="Button"
              alt="Edit Icon"
              sx={{ width: 'unset' }}
              onClick={() =>
                history.push('edit-amc-authorised-signatory', {
                  amcAuthorisedSignatoryId: amcAuthorisedSignatoryTypeDetails?.id,
                })
              }
            />
          </IconButton>
        </Box>
        {isLoading ? (
          <LinearProgress sx={{ ml: 5, mr: 5 }} />
        ) : (
          amcAuthorisedSignatoryTypeDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={'Name (Individual)'}
                      description={amcAuthorisedSignatoryTypeDetails.user.firstName}
                    />
                    <KeyValue
                      title={'Leegality Name'}
                      description={amcAuthorisedSignatoryTypeDetails.leegalityName}
                    />
                    <KeyValue
                      title={'Pan'}
                      description={amcAuthorisedSignatoryTypeDetails.panNumber}
                    />
                    <KeyValue
                      title={'Email Id'}
                      description={amcAuthorisedSignatoryTypeDetails.user.email}
                    />
                    <KeyValue
                      title={'Mobile Number'}
                      description={amcAuthorisedSignatoryTypeDetails.user.phone}
                    />
                    <KeyValue
                      title={'Pincode'}
                      description={amcAuthorisedSignatoryTypeDetails.pincode}
                    />
                    <KeyValue
                      title={'Building Number'}
                      description={amcAuthorisedSignatoryTypeDetails.buildingNo}
                    />
                    <KeyValue
                      title={'Street Name'}
                      description={amcAuthorisedSignatoryTypeDetails.streetName}
                    />
                    <KeyValue
                      title={'State'}
                      description={amcAuthorisedSignatoryTypeDetails.state}
                    />
                    <KeyValue title={'City'} description={amcAuthorisedSignatoryTypeDetails.city} />
                    <KeyValue
                      title={'Country'}
                      description={amcAuthorisedSignatoryTypeDetails.country}
                    />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
